/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import classes from "./inlineItem.module.css";
import Input from "../../../../component/inputpm";
import InfoIcon from "../../../../asset/images/info.svg";
import Collapse from "@mui/material/Collapse";
import UOM from "../../../../helper/UOM.js";
import jp from "jsonpath";
import { Tooltip } from "@mui/material";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../../helper/currencyFormatter";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ClipboardWithGear } from "../../../../component/icons/icons.js";
import OfferingProductSpecCharacteristicsExistingDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog.js";

const insClass = (selected, selectionType) =>
  selected
    ? selectionType === "frozen"
      ? classes.freezeSelection
      : [classes.planOuterDiv, classes.selectedPlanOuterDiv].join(" ")
    : selectionType === "frozen"
      ? classes.freezeSelection
      : classes.planOuterDiv;

const InlineItem = (props) => {
  const t = props.t;
  const [more, setMore] = useState(false);
  const [showBom, toggleShowBom] = useState(false);
  const [showChar, setShowChar] = useState(false);
  const changeComponentQuantity = (item, value, isBlur = false) => {
    let itemIndex = props.bucketsList.findIndex(
      (a) => a.id === item.componentType,
    );

    // Allow empty value during typing (not on blur)
    if (!isBlur && (value === '' || value === null || value === undefined)) {
      props.changeComponentQuantity(item.id, value);
      return;
    }

    // Convert to number for validation
    const numValue = parseInt(value);

    // If not a valid number and not blurring, allow it (for partial input like "-")
    if (isNaN(numValue) && !isBlur) {
      props.changeComponentQuantity(item.id, value);
      return;
    }

    // If NaN on blur, reset to minimum valid value
    if (isNaN(numValue) && isBlur) {
      props.changeComponentQuantity(item.id, 1);
      return;
    }

    let allowedRange = null;
    // Since first bucket can only be depended on Packaged Solution so we just have to check if relationship is there then check for min and max quantity only
    if (itemIndex === 0) {
      if (
        item.relationShips &&
        item.relationShips.dependsOn &&
        item.relationShips.dependsOn.length > 0
      ) {
        // if (
        //   value < item.relationShips.dependsOn[0].cardinality.range.min ||
        //   value > item.relationShips.dependsOn[0].cardinality.range.max
        // ) {
        //   // Invalid value entered
        // } else {
        //   props.changeComponentQuantity(item.id, value);
        // }
        const dep = item.relationShips.dependsOn[0];
        const dependerQty = props.quantity || 1; // packaged solution quantity
        allowedRange = calculateDependeeRange(dep, dependerQty);

        // Clamp to valid range for all valid numbers
        const clampedValue = Math.max(allowedRange.min, Math.min(allowedRange.max, numValue));
        props.changeComponentQuantity(item.id, clampedValue);
        return;
      } else {
        props.changeComponentQuantity(item.id, numValue);
        return;
      }

      //   if (value >= allowedRange.min && value <= allowedRange.max) {
      //     props.changeComponentQuantity(item.id, value);
      //   }
      // } else {
      //   props.changeComponentQuantity(item.id, value);
      // }
    } else {
      if (
        item.relationShips &&
        item.relationShips.dependsOn &&
        item.relationShips.dependsOn.length > 0
      ) {
        let dependersIds = jp.query(
          item.relationShips.dependsOn,
          "$..depender",
        );
        let selectedIds = jp.query(
          props.componentData,
          "$..[?(@.selected)].id",
        );
        // If item is directly depended on packaged solution and cardinality is Range
        if (dependersIds.includes(props.productId)) {
          let obj = item.relationShips.dependsOn.find(
            (x) => x.depender === props.productId,
          );
          // if (item.maxQuantity && item.maxQuantity > 0) {
          //   if (value > 0 && value <= item.maxQuantity) {
          //     props.changeComponentQuantity(item.id, value);
          //   }
          // } else {
          if (item.maxQuantity && item.maxQuantity > 0) {
            // Clamp between 1 and maxQuantity
            const clampedValue = Math.max(1, Math.min(item.maxQuantity, numValue));
            props.changeComponentQuantity(item.id, clampedValue);
            return;
          }
          // } else {
          //   if (obj.cardinality.range.max > 0) {
          //     if (value > 0) {
          //       if (
          //         value < obj.cardinality.range.min ||
          //         value > obj.cardinality.range.max
          //       ) {
          //         // Invalid value entered
          //       } else {
          //         props.changeComponentQuantity(item.id, value);
          //       }
          //     }
          //   } else {
          //     if (value > 0) {
          //       props.changeComponentQuantity(item.id, value);
          //     }
          //   }
          // }
        } else {
          // if item is depended on other item
          for (let i = 0; i < dependersIds.length; i++) {
            if (selectedIds.includes(dependersIds[i])) {
              let obj = item.relationShips.dependsOn.find(
                (x) => x.depender === dependersIds[i],
              );
              const dependerItem = props.componentData.find(c => c.id === obj.depender);
              const dependerQty = dependerItem?.quantity || 1;
              allowedRange = calculateDependeeRange(obj, dependerQty);

              // Use item.maxQuantity if already calculated, otherwise use allowedRange
              const maxQty = (item.maxQuantity && item.maxQuantity > 0)
                ? item.maxQuantity
                : allowedRange.max;

              // Clamp to valid range
              const clampedValue = Math.max(allowedRange.min, Math.min(maxQty, numValue));
              props.changeComponentQuantity(item.id, clampedValue);
              return;
            }

            // if (value > 0 && value >= allowedRange.min && value <= maxQty) {
            //   props.changeComponentQuantity(item.id, value);
            // }

            // if (item.maxQuantity && item.maxQuantity > 0) {
            //   if (
            //     value >= obj.cardinality.range.min &&
            //     value <= item.maxQuantity
            //   ) {
            //     props.changeComponentQuantity(item.id, value);
            //   }
            // } else {
            //   if (obj.cardinality.range.max > 0) {
            //     if (value > 0) {
            //       if (
            //         value < obj.cardinality.range.min ||
            //         value > obj.cardinality.range.max
            //       ) {
            //         // Invalid value entered
            //       } else {
            //         props.changeComponentQuantity(item.id, value);
            //       }
            //     }
            //   } else {
            //     if (value > 0) {
            //       props.changeComponentQuantity(item.id, value);
            //     }
            //   }
            // }

          }
        }
      } else {
        props.changeComponentQuantity(item.id, value);
        return;
      }
    }
  };

  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "DATA_MB") {
      return "Megabyte";
    } else if (val === "DATA_GB") {
      return "Gigabyte";
    } else {
      return "";
    }
  };

  const checkFulfillable = (values) => {
    if (values && values.length > 0) {
      var index = values.findIndex(
        (x) => x.attrName.toLowerCase() === "fulfillable",
      );
      if (index > -1) {
        if (values[index].attrValue === "false") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const handleCharacteristicsUpdate = (updatedCharacteristics) => {
    props.handleCharacteristicsUpdate(props.item, updatedCharacteristics);
  };

  const handleCloseSpecificationDialog = () => {
    console.log("close product charcterstics");
  };

  const calculateDependeeRange = (dependency, dependerQuantity) => {
    const dependerQtyMin = dependency.quantity?.range?.min
      ? parseInt(dependency.quantity.range.min)
      : 1;

    const cardinalityMin = dependency.cardinality?.range?.min !== null &&
      dependency.cardinality?.range?.min !== undefined
      ? parseInt(dependency.cardinality.range.min)
      : 1;
    const cardinalityMax = dependency.cardinality?.range?.max !== null &&
      dependency.cardinality?.range?.max !== undefined
      ? parseInt(dependency.cardinality.range.max)
      : cardinalityMin;

    const isFlexibleScaling = (cardinalityMin === 0 && cardinalityMax === 0 && dependency.cardinality?.type === null) && dependency.dependencyType !== "Mandatory";
    if (isFlexibleScaling) {
      // For flexible scaling (0,0), allow 1 to dependerQuantity range
      return {
        min: 1,
        max: dependerQuantity
      };
    }

    const multiplier = Math.ceil(dependerQuantity / dependerQtyMin);

    // For non-Mandatory dependencies, allow user to reduce to 1
    // const minQuantity = dependency.dependencyType === "Mandatory" 
    // ? cardinalityMin * multiplier 
    // : 1;

    return {
      min: cardinalityMin * multiplier,
      max: cardinalityMax * multiplier
    };
  };

  const hasDependents = (item) => {
    return props.componentData.some(component => {
      if (component.relationShips?.dependsOn) {
        return component.relationShips.dependsOn.some(dep =>
          dep.depender === item.id && dep.quantity
        );
      }
      return false;
    });
  };

  useEffect(() => {
    if (props.showProductsDescription === false) {
      setMore(false)
    }
  }, [props.showProductsDescription])

  return (
    <>
      {props.item.customerViewable && (
        <Grid container spacing={0} justifyContent="center">
          {props.item.variants && props.item.variants.length > 0 ? (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <div
                className={insClass(
                  props.item.selected ? props.item.selected : "",
                )}
              >
                <div className={classes.planInnerDiv}>
                  <div className={classes.planHeader}>
                    <div className={classes.planFirstChild}>
                      <TableContainer>
                        <Table className={classes.noBorder}>
                          <TableBody>
                            <TableRow>
                              {!props.isBundle ? (
                                <TableCell>
                                  <label>{props.item.name}</label>
                                </TableCell>
                              ) : (
                                <>
                                  {props.item.maxQuantity ? (
                                    <Tooltip
                                      title={
                                        t("MAXIMUM_QUANTITY_ALLOWED") +
                                        props.item.maxQuantity
                                      }
                                    >
                                      <TableCell
                                        valign="middle"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {props.item.relationShips ?
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected ||
                                                  props.item.isExact
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value, false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected ||
                                                props.item.isExact
                                              }
                                            />
                                          </>
                                          :
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value, false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected
                                              }
                                            />
                                          </>
                                        }
                                        <label
                                          style={{
                                            position: "relative",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {props.item.name}
                                        </label>
                                        {/* <div style={{ fontSize: 12, fontWeight: 'normal' }}>
																{props.item.maxQuantity > 0 && 'Maximum quantity allowed: ' + props.item.maxQuantity}
															</div> */}
                                      </TableCell>
                                    </Tooltip>
                                  ) : (
                                    <>
                                      <TableCell
                                        valign="middle"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {props.item.relationShips ?
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected ||
                                                  props.item.isExact
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value, false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected ||
                                                props.item.isExact ||
                                                props.item.isCoreItem
                                              }
                                            />
                                          </>
                                          :
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value, false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected
                                              }
                                            />
                                          </>
                                        }
                                        <label
                                          style={{
                                            position: "relative",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {props.item.name}
                                        </label>
                                        <span
                                          style={{
                                            visibility: props.item.description
                                              ? "visible"
                                              : "hidden",
                                          }}
                                          className={classes.infoButton}
                                        >
                                          {props.showProductsDescription ?
                                            ''
                                            :
                                            <Tooltip
                                              title={
                                                more
                                                  ? t("SHOW_LESS")
                                                  : t("SHOW_MORE")
                                              }
                                            >
                                              <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setMore(!more);
                                                }}
                                              >
                                                <g clipPath="url(#clip0_380_7010)">
                                                  <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                                    fill="#96A1B0"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_380_7010">
                                                    <rect
                                                      width="12"
                                                      height="12"
                                                      fill="white"
                                                    />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </Tooltip>
                                          }
                                        </span>
                                        {props.item.productSpec &&
                                          props.item.productSpec.category && (
                                            <span
                                              style={{ top: "2px" }}
                                              className={classes.infoButton}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // props.openProductSpecification(props.item);
                                                props.setShowChar(props.item);
                                              }}
                                            >
                                              <Tooltip
                                                title={t(
                                                  "PRODUCT_SPECIFICATION",
                                                )}
                                              >
                                                <ClipboardWithGear />
                                              </Tooltip>
                                            </span>
                                          )}
                                      </TableCell>
                                      {/* <TableCell>
																			<label style={{ position: 'relative', top: '5px' }}>
																				{props.item.description}
																			</label>
																		</TableCell> */}
                                    </>
                                  )}
                                </>
                              )}
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    {/* <div className={classes.planSecondChild}>
											<Tooltip title={more ? t('SHOW_LESS') : t('SHOW_MORE')}>
												<img
													src={InfoIcon}
													onClick={(e) => {
														e.stopPropagation();
														setMore(!more);
													}}
													style={{ marginLeft: "20px", visibility: props.item.description ? 'visible' : 'hidden' }}
													className="salesWizardInfoIcon"
													alt={InfoIcon}
												/>
											</Tooltip>
										</div> */}
                  </div>

                  {/* Show variants start */}

                  {props.item.variants.map((vr) => (
                    <div
                      className="roundCorners borderOutline"
                      style={{ marginBottom: ".7rem" }}
                    >
                      <div
                        className={classes.planHeader}
                        style={{ marginTop: 10 }}
                        onClick={() => {
                          props.updateComponentVariantSelection(
                            props.item,
                            vr.productId,
                          );
                        }}
                        key={vr.productId}
                      >
                        <div className={classes.planFirstChild}>
                          <TableContainer>
                            <Table className={classes.noBorder}>
                              <TableBody>
                                <TableRow>
                                  <TableCell className={classes.checkboxColumn}>
                                    <div className={classes.round}>
                                      <input
                                        type="checkbox"
                                        readOnly
                                        checked={vr.selected}
                                      />
                                      <label htmlFor="checkbox"></label>
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    valign="middle"
                                    style={{ width: "45rem" }}
                                  >
                                    {/* <Input
																	className={classes.quantityInput}
																	type="number"
																	min="0"
																	step="1"
																	max="100"
																	value={props.item.quantity}
																	onClick={(e) => {
																		e.stopPropagation();
																		changeComponentQuantity(props.item, e.target.value);
																	}}
																	onChange={(e) => {
																		e.stopPropagation();
																		changeComponentQuantity(props.item, e.target.value);
																	}}
																	disabled={!props.item.selected}
																/> */}
                                    <div style={{ fontWeight: "600" }}>
                                      {vr.name}
                                    </div>
                                    <div className="textLighter">
                                      {vr.description}
                                    </div>
                                  </TableCell>
                                </TableRow>
                                {/* <TableRow>
															<TableCell></TableCell>
															<TableCell>
                                                                <label style={{ position:'relative', top: '5px' }}>
                                                                    {vr.description}
                                                                </label>
                                                            </TableCell>
                                                        </TableRow> */}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          {/* {vr.name} */}
                        </div>
                        <div
                          className={classes.planSecondChild}
                          style={{ paddingTop: 2 }}
                        >
                          {checkFulfillable(props.item.customAttributes) &&
                            props.providerType === "SALES_CHNL_PROVIDER" && (
                              <>
                                {props.providerType === "SALES_CHNL_PROVIDER" ||
                                  props.publicBrowsing
                                  ? vr.price.purchasePrice === "0.0"
                                    ? ""
                                    : currencyFormatter(
                                      UOM.priceFunction(
                                        vr.price,
                                        vr.id,
                                        props.selectedPromo,
                                        t,
                                      ),
                                    )
                                  : props.item.priceType === "RC"
                                    ? currencyFormatter("", false)
                                    : currencyFormatter("", false)}

                                {vr.price.purchasePrice !== "0.0" && (
                                  <span>
                                    {props.item.priceType === "NTC"
                                      ? props.item.priceTenure > 1
                                        ? // ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM)+ ' for ' + props.item.priceTenure + ' ' + getPriceTenureUOM(props.item.priceTenureUOM) + 's' + ')' : ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ')' : ''}
                                        // ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ' for ' + props.item.priceTenure + ' ' + getPriceTenureUOM(props.item.priceTenureUOM) + 's' + ')' : ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ')' : ''
                                        ` (per ${getPriceTenureUOM(props.item.priceTenureUOM)} for ${props.item.priceTenure} ${getPriceTenureUOM(props.item.priceTenureUOM)}s)`
                                        : ` (per ${getPriceTenureUOM(props.item.priceTenureUOM)} for ${props.item.priceTenure} ${getPriceTenureUOM(props.item.priceTenureUOM)})`
                                      : ""}
                                    {props.item.priceType === "RC"
                                      ? props.item.priceTenure
                                        ? props.item.priceTenure > 1
                                          ? // ' (' + 'per ' + props.item.priceTenure + ' ' + getPriceTenureUOM(props.item.priceTenureUOM) + 's' + ')' :
                                          // ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ')' : '' : ''
                                          ` (per ${props.item.priceTenure} ${getPriceTenureUOM(props.item.priceTenureUOM)}s)`
                                          : ` (per ${getPriceTenureUOM(props.item.priceTenureUOM)})`
                                        : ""
                                      : ""}
                                  </span>
                                )}
                              </>
                            )}
                          {props.showProductsDescription ?
                            ''
                            :
                            <Tooltip
                              title={
                                more
                                  ? t("SHOW_LESS")
                                  : t("SHOW_MORE")
                              }
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setMore(!more);
                                }}
                                style={{ marginLeft: '5px' }}
                              >
                                <g clipPath="url(#clip0_380_7010)">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                    fill="#96A1B0"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_380_7010">
                                    <rect
                                      width="12"
                                      height="12"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </Tooltip>
                          }
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* Show variants end */}
                  {/* Start: Show/hide description of item */}
                  <Collapse in={more || props.showProductsDescription}>
                    <div
                      className={classes.planDescription}
                      dangerouslySetInnerHTML={{
                        __html: props.item.description,
                      }}
                    />
                    {/* {props.item.inventoryItemAndDetail &&
											<span style={{ marginRight: '24px' }}>
												<Tooltip title={t('AVAILABLE_TO_PROMISE')}><span style={{ fontWeight: 'normal' }}>{t('ATP')}: </span></Tooltip>{props.item.inventoryItemAndDetail[0].atpqty}
											</span>
										} */}
                    {props.providerType === "SALES_CHNL_PROVIDER" && (
                      <>
                        {props.item.otherPrices &&
                          props.item.otherPrices.length > 0 && (
                            <>
                              <div style={{ marginTop: "16px" }}>
                                <b>{t("OTHER_PRICES")}</b>
                                <ul style={{ marginTop: "4px" }}>
                                  {props.item.otherPrices.map(
                                    (price, index) => (
                                      <li key={index}>
                                        {t(price.priceType)}:{" "}
                                        <b>
                                          {currencyFormatter(price.price, true)}
                                        </b>
                                        {price.priceType === "USAGE_CHARGE" &&
                                          price.priceTenureUOM &&
                                          " (" +
                                          "per " +
                                          getPriceTenureUOM(
                                            price.priceTenureUOM,
                                          ) +
                                          ")"}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </Collapse>
                  {/* End: Show/hide description of item */}
                </div>
              </div>
            </Grid>
          ) : (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <div
                className={insClass(
                  props.item.selected ? props.item.selected : "",
                )}
                onClick={(e) => {
                  e.preventDefault();
                  // Check if trying to deselect a mandatory dependency
                  if (props.item.selected && props.item.relationShips?.dependsOn) {
                    const isMandatory = props.item.relationShips.dependsOn.some(dep =>
                      dep.dependencyType === "Mandatory"
                    );

                    // If it's mandatory and has matching dependency, prevent deselection
                    if (isMandatory && props.hasMatchingDependency) {
                      return; // Don't allow deselection
                    }
                  }
                  !props.item.defaultSelected &&
                    !props.item.componentSelected &&
                    props.hasMatchingDependency &&
                    props.updateComponentSelection(props.item);
                }}
              >
                <div className={classes.planInnerDiv}>
                  <div className={classes.planHeader}>
                    <div className={classes.planFirstChild}>
                      <TableContainer>
                        <Table className={classes.noBorder}>
                          <TableBody>
                            <TableRow>
                              <TableCell className={classes.checkboxColumn}>
                                <div className={classes.round}>
                                  <input
                                    type="checkbox"
                                    readOnly
                                    checked={props.item.selected}
                                  />
                                  <label htmlFor="checkbox"></label>
                                </div>
                              </TableCell>
                              {!props.isBundle ? (
                                <TableCell>
                                  <label>{props.item.name}</label>
                                  <span
                                    style={{
                                      visibility: props.item.description
                                        ? "visible"
                                        : "hidden",
                                      bottom: "-1px",
                                    }}
                                    className={classes.infoButton}
                                  >
                                    {props.showProductsDescription ?
                                      ''
                                      :
                                      <Tooltip
                                        title={
                                          more
                                            ? t("SHOW_LESS")
                                            : t("SHOW_MORE")
                                        }
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 12 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setMore(!more);
                                          }}
                                        >
                                          <g clipPath="url(#clip0_380_7010)">
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                              fill="#96A1B0"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_380_7010">
                                              <rect
                                                width="12"
                                                height="12"
                                                fill="white"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </Tooltip>
                                    }
                                  </span>
                                  {props.item.productSpec &&
                                    props.item.productSpec.category && (
                                      <span
                                        style={{ top: "2px" }}
                                        className={classes.infoButton}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          // props.openProductSpecification(props.item);
                                          props.setShowChar(props.item);
                                        }}
                                      >
                                        <Tooltip
                                          title={t("PRODUCT_SPECIFICATION")}
                                        >
                                          <ClipboardWithGear />
                                        </Tooltip>
                                      </span>
                                    )}
                                </TableCell>
                              ) : (
                                <>
                                  {props.item.maxQuantity ? (
                                    <Tooltip
                                      title={
                                        t("MAXIMUM_QUANTITY_ALLOWED") +
                                        props.item.maxQuantity
                                      }
                                    >
                                      <TableCell
                                        valign="middle"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {props.item.relationShips ?
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected ||
                                                  props.item.isExact
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value, false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected ||
                                                props.item.isExact
                                              }
                                            />
                                          </>
                                          :
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected
                                              }
                                            />
                                          </>
                                        }
                                        <label
                                          style={{
                                            position: "relative",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {props.item.name}
                                        </label>
                                        <span
                                          style={{
                                            visibility: props.item.description
                                              ? "visible"
                                              : "hidden",
                                          }}
                                          className={classes.infoButton}
                                        >
                                          {props.showProductsDescription ?
                                            ''
                                            :
                                            <Tooltip
                                              title={
                                                more
                                                  ? t("SHOW_LESS")
                                                  : t("SHOW_MORE")
                                              }
                                            >
                                              <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setMore(!more);
                                                }}
                                                style={{ position: 'relative', top: '3px' }}
                                              >
                                                <g clipPath="url(#clip0_380_7010)">
                                                  <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                                    fill="#96A1B0"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_380_7010">
                                                    <rect
                                                      width="12"
                                                      height="12"
                                                      fill="white"
                                                    />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </Tooltip>
                                          }
                                        </span>
                                        {props.item.productSpec &&
                                          props.item.productSpec.category && (
                                            <span
                                              style={{ top: "2px" }}
                                              className={classes.infoButton}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // props.openProductSpecification(props.item);
                                                props.setShowChar(props.item);
                                              }}
                                            >
                                              <Tooltip
                                                title={t(
                                                  "PRODUCT_SPECIFICATION",
                                                )}
                                              >
                                                <ClipboardWithGear />
                                              </Tooltip>
                                            </span>
                                          )}
                                        {/* <div style={{ fontSize: 12, fontWeight: 'normal' }}>
																	{props.item.maxQuantity > 0 && 'Maximum quantity allowed: ' + props.item.maxQuantity}
																</div> */}
                                      </TableCell>
                                    </Tooltip>
                                  ) : (
                                    <>
                                      <TableCell
                                        valign="middle"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {props.item.relationShips ?
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected ||
                                                  props.item.isExact
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value, false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              // disabled={
                                              //   !props.item.selected ||
                                              //   props.item.isExact ||
                                              //   props.item.isCoreItem
                                              // }
                                              disabled={
                                                props.item.isExact ||
                                                (() => {
                                                  // If item is a dependee, check if depender is selected
                                                  if (props.item.relationShips?.dependsOn) {
                                                    const hasSelectedDepender = props.item.relationShips.dependsOn.some(dep => {
                                                      let depender = props.componentData?.find(c => c.id === dep.depender);

                                                      // If not found, it might be a variant ID - searching within variants
                                                      if (!depender) {
                                                        depender = props.componentData?.find(c => {
                                                          if (c.variants && c.variants.length > 0) {
                                                            return c.variants.some(v => v.id === dep.depender);
                                                          }
                                                          return false;
                                                        });
                                                      }

                                                      // If found by variant ID, check if that specific variant is selected
                                                      if (depender && depender.variants && depender.variants.length > 0) {
                                                        const matchingVariant = depender.variants.find(v => v.id === dep.depender);
                                                        if (matchingVariant) {
                                                          // return matchingVariant.selected;
                                                          if (!matchingVariant.selected) return false;
                                                          // quantity match check for variant-based depender
                                                          const dependerQty = parseInt(depender.quantity) || 0;
                                                          const min = parseInt(dep.quantity?.range?.min) || 1;
                                                          const max = parseInt(dep.quantity?.range?.max) || Infinity;
                                                          return dependerQty >= min && dependerQty <= max;
                                                        }
                                                      }
                                                      // return depender?.selected;
                                                      if (!depender?.selected) return false;
                                                      // quantity match check for normal depender
                                                      const dependerQty = parseInt(depender.quantity) || 0;
                                                      const min = parseInt(dep.quantity?.range?.min) || 1;
                                                      const max = parseInt(dep.quantity?.range?.max) || Infinity;
                                                      return dependerQty >= min && dependerQty <= max;
                                                    });
                                                    return !hasSelectedDepender;
                                                  }

                                                  // Core items with dependents can be edited
                                                  if (props.item.isCoreItem && hasDependents(props.item)) {
                                                    return false;
                                                  }

                                                  // Otherwise must be selected
                                                  return !props.item.selected;
                                                })()
                                              }

                                            />
                                            {/* {console.log('props.disabled', props.item.selected, props.item.isExact, props.item.isCoreItem, hasDependents(props.item), props)} */}
                                          </>
                                          :
                                          <>
                                            <Input
                                              className={classes.quantityInput}
                                              type={
                                                !props.item.selected
                                                  ? "text"
                                                  : "number"
                                              }
                                              min="0"
                                              step="1"
                                              max="100"
                                              value={props.item.quantity}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // changeComponentQuantity(
                                                //   props.item,
                                                //   e.target.value,
                                                // );
                                              }}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  false
                                                );
                                              }}
                                              onBlur={(e) => {
                                                e.stopPropagation();
                                                changeComponentQuantity(
                                                  props.item,
                                                  e.target.value,
                                                  true  // Blur event - validate and clamp
                                                );
                                              }}
                                              disabled={
                                                !props.item.selected || props.item.isCoreItem
                                              }
                                            />
                                          </>
                                        }
                                        <label
                                          style={{
                                            position: "relative",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {props.item.name}
                                        </label>
                                        <span
                                          style={{
                                            visibility: props.item.description
                                              ? "visible"
                                              : "hidden",
                                            top: "2px",
                                          }}
                                          className={classes.infoButton}
                                        >
                                          {props.showProductsDescription ?
                                            ''
                                            :
                                            <Tooltip
                                              title={
                                                more
                                                  ? t("SHOW_LESS")
                                                  : t("SHOW_MORE")
                                              }
                                            >
                                              <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setMore(!more);
                                                }}
                                                style={{ position: 'relative', top: '2px' }}
                                              >
                                                <g clipPath="url(#clip0_380_7010)">
                                                  <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                                    fill="#96A1B0"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_380_7010">
                                                    <rect
                                                      width="12"
                                                      height="12"
                                                      fill="white"
                                                    />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </Tooltip>
                                          }
                                        </span>
                                        {props.item.productSpec &&
                                          props.item.productSpec.category && (
                                            <span
                                              style={{ top: "2px" }}
                                              className={classes.infoButton}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                // props.openProductSpecification(props.item);
                                                props.setShowChar(props.item);
                                              }}
                                            >
                                              <Tooltip
                                                title={t("PRODUCT_SPECIFICATION")}
                                              >
                                                <ClipboardWithGear />
                                              </Tooltip>
                                            </span>
                                          )}
                                      </TableCell>
                                    </>
                                  )}
                                </>
                              )}
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>

                    {props.item.price ? (
                      <div className={classes.planSecondChild}>
                        {checkFulfillable(props.item.customAttributes) &&
                          props.providerType === "SALES_CHNL_PROVIDER" && (
                            <>
                              {props.providerType === "SALES_CHNL_PROVIDER" ||
                                props.publicBrowsing
                                ? props.item.price.purchasePrice === "0.0"
                                  ? ""
                                  : currencyFormatter(
                                    UOM.priceFunction(
                                      props.item.price,
                                      props.item.id,
                                      props.selectedPromo,
                                      t,
                                    ),
                                  )
                                : props.item.priceType === "RC"
                                  ? currencyFormatter("", false)
                                  : currencyFormatter("", false)}

                              {props.item.price.purchasePrice !== "0.0" && (
                                <span>
                                  {props.item.priceType === "NTC"
                                    ? props.item.priceTenure > 1
                                      ? // ' (' + 'per ' + props.item.priceTenure + ' ' + getPriceTenureUOM(props.item.priceTenureUOM) + 's' + ')' : ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ')' : ''}
                                      // ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ' for ' + props.item.priceTenure + ' ' + getPriceTenureUOM(props.item.priceTenureUOM) + 's' + ')' :' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ')' : ''
                                      ` (per ${getPriceTenureUOM(props.item.priceTenureUOM)} for ${props.item.priceTenure} ${getPriceTenureUOM(props.item.priceTenureUOM)}s)`
                                      : ` (per ${getPriceTenureUOM(props.item.priceTenureUOM)} for ${props.item.priceTenure} ${getPriceTenureUOM(props.item.priceTenureUOM)})`
                                    : ""}
                                  {props.item.priceType === "RC"
                                    ? props.item.priceTenure
                                      ? props.item.priceTenure > 1
                                        ? // ' (' + 'per ' + props.item.priceTenure + ' ' + getPriceTenureUOM(props.item.priceTenureUOM) + 's' + ')' :
                                        // ' (' + 'per ' + getPriceTenureUOM(props.item.priceTenureUOM) + ')' : '' : ''
                                        ` (per ${props.item.priceTenure} ${getPriceTenureUOM(props.item.priceTenureUOM)}s)`
                                        : ` (per ${getPriceTenureUOM(props.item.priceTenureUOM)})`
                                      : ""
                                    : ""}
                                </span>
                              )}
                            </>
                          )}
                        {/* <Tooltip title={more ? t('SHOW_LESS') : t('SHOW_MORE')}>
													<img
														src={InfoIcon}
														onClick={(e) => {
															e.stopPropagation();
															setMore(!more);
														}}
														style={{ marginLeft: "20px", visibility: props.item.description ? 'visible' : 'hidden' }}
														className="salesWizardInfoIcon"
														alt={InfoIcon}
													/>
												</Tooltip> */}
                        {props.item.bom && props.item.bom.length > 0 && (
                          <Tooltip title={t("EXPAND_PRODUCTS")}>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              style={{ float: "right", marginLeft: "10px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleShowBom(!showBom);
                              }}
                            >
                              {showBom ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    ) : (
                      <div className={classes.planSecondChild}>
                        {props.showProductsDescription ?
                          ''
                          :
                          <Tooltip
                            title={
                              more
                                ? t("SHOW_LESS")
                                : t("SHOW_MORE")
                            }
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={(e) => {
                                e.stopPropagation();
                                setMore(!more);
                              }}
                            >
                              <g clipPath="url(#clip0_380_7010)">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V6C5.5 5.72386 5.72386 5.5 6 5.5Z"
                                  fill="#96A1B0"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_380_7010">
                                  <rect
                                    width="12"
                                    height="12"
                                    fill="white"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </Tooltip>
                        }
                        {props.item.bom && props.item.bom.length > 0 && (
                          <Tooltip title={t("EXPAND_PRODUCTS")}>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              style={{ float: "right", marginLeft: "10px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleShowBom(!showBom);
                              }}
                            >
                              {showBom ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}
                        {props.item.productSpec &&
                          props.item.productSpec.category && (
                            <span
                              style={{ top: "2px" }}
                              className={classes.infoButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                // props.openProductSpecification(props.item);
                                props.setShowChar(props.item);
                              }}
                            >
                              <Tooltip title={t("PRODUCT_SPECIFICATION")}>
                                <ClipboardWithGear />
                              </Tooltip>
                            </span>
                          )}
                      </div>
                    )}
                  </div>

                  {/* Show bom start */}
                  <Collapse in={showBom}>
                    {props.item.bom &&
                      props.item.bom.length > 0 &&
                      props.item.bom
                        .sort((a, b) =>
                          a && b ? a.displaySequence - b.displaySequence : 0,
                        )
                        .map((bom, index) => (
                          <div
                            key={bom.id}
                            style={{ marginLeft: "36px", marginRight: "36px" }}
                          >
                            <BomItem
                              data={bom}
                              parentItem={props.item}
                              level={1}
                            />
                          </div>
                        ))}
                  </Collapse>

                  {/* Show assembly start */}
                  {props.item.children.map((ch) => (
                    <React.Fragment key={ch.id}>
                      <ChildItem
                        data={ch}
                        parentItem={props.item}
                        updateAssemblyVariantsSelection={
                          props.updateAssemblyVariantsSelection
                        }
                      />
                    </React.Fragment>
                  ))}
                  {/* Show assembly end */}

                  {/* Start: Show/hide description of item */}
                  <Collapse in={more || props.showProductsDescription}>
                    <div
                      className={classes.planDescription}
                      dangerouslySetInnerHTML={{
                        __html: props.item.description,
                      }}
                    />
                    {/* {props.item.inventoryItemAndDetail && props.item.inventoryItemAndDetail.length > 0 &&
											<span style={{ marginRight: '24px' }}>
												<Tooltip title={t('AVAILABLE_TO_PROMISE')}><span style={{ fontWeight: 'normal' }}>{t('ATP')}: </span></Tooltip>{props.item.inventoryItemAndDetail[0].atpqty}
											</span>
										} */}
                    {props.providerType === "SALES_CHNL_PROVIDER" && (
                      <>
                        {props.item.otherPrices &&
                          props.item.otherPrices.length > 0 && (
                            <>
                              <div style={{ marginTop: "16px" }}>
                                <b>{t("OTHER_PRICES")}</b>
                                <ul style={{ marginTop: "4px" }}>
                                  {props.item.otherPrices.map(
                                    (price, index) => (
                                      <li key={index}>
                                        {t(price.priceType)}:{" "}
                                        <b>
                                          {currencyFormatter(price.price, true)}
                                        </b>
                                        {price.priceType === "USAGE_CHARGE" &&
                                          price.priceTenureUOM &&
                                          " (" +
                                          "per " +
                                          getPriceTenureUOM(
                                            price.priceTenureUOM,
                                          ) +
                                          ")"}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </Collapse>
                  {/* End: Show/hide description of item */}

                  {/* Start: Show/hide product characterstics */}
                  {/* {showChar && */}
                  <Collapse in={props.item.showChar}>
                    <div className={classes.planDescription} />
                    <OfferingProductSpecCharacteristicsExistingDialog
                      t={t}
                      open={true}
                      productId={props.item.id}
                      productName={props.item.name}
                      onClose={handleCloseSpecificationDialog}
                      componentProductCharacteristics={
                        props.item.productSpec ? props.item.productSpec : {}
                      }
                      changedCharacteristics={
                        props.item.characteristics
                          ? props.item.characteristics
                          : []
                      }
                      onCharacteristicsChange={handleCharacteristicsUpdate}
                      screen="checkout"
                    />
                  </Collapse>
                  {/* } */}
                  {/* Start: Show/hide product characterstics */}
                </div>
              </div>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};

const ChildItem = (child) => {
  return (
    <>
      <div
        className={classes.planHeaderChildItem}
        style={{ marginTop: 10, paddingLeft: 30 }}
        key={child.data.id}
      // onClick={() => {
      // 	props.updateComponentVariantSelection(props.item, child.productId);
      // }}
      >
        <div className={classes.planFirstChild} style={{ width: "100%" }}>
          <TableContainer>
            <Table className={classes.noBorder}>
              <TableBody>
                <TableRow>
                  {/* <TableCell className={classes.checkboxColumn}>
								<div className={classes.round}>
									<input type="checkbox" readOnly checked={child.parentItem.selected} />
									<label htmlFor="checkbox"></label>
								</div>
							</TableCell> */}
                  <TableCell valign="middle">{child.data.name}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {child.data.children &&
          child.data.children.length > 0 &&
          child.data.children.map((item) => (
            <React.Fragment key={item.id}>
              <ChildItem
                data={item}
                parentItem={child.parentItem}
                updateAssemblyVariantsSelection={
                  child.updateAssemblyVariantsSelection
                }
              />
            </React.Fragment>
          ))}
        {child.data.variants &&
          child.data.variants.length > 0 &&
          child.data.variants.map((variant) => (
            <React.Fragment key={variant.productId}>
              <ChildVariant
                data={variant}
                parentItem={child.parentItem}
                updateAssemblyVariantsSelection={
                  child.updateAssemblyVariantsSelection
                }
              />
            </React.Fragment>
          ))}
      </div>
    </>
  );
};

const ChildVariant = (vr) => {
  return (
    <div
      className={classes.planHeader}
      style={{ marginTop: 10, paddingLeft: 30 }}
      key={vr.data.productId}
      onClick={(e) => {
        e.stopPropagation();
        vr.updateAssemblyVariantsSelection(vr.data.productId, vr.parentItem.id);
      }}
    >
      <div className={classes.planFirstChild} style={{ width: "100%" }}>
        <TableContainer>
          <Table className={classes.noBorder}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.checkboxColumn}>
                  <div className={classes.round}>
                    <input
                      type="checkbox"
                      readOnly
                      checked={
                        vr.parentItem.selectedVariant === vr.data.productId
                      }
                    />
                    <label htmlFor="checkbox"></label>
                  </div>
                </TableCell>
                <TableCell valign="middle">{vr.data.name}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

const BomItem = (bom) => {
  return (
    bom.data.customerViewable && (
      <div
        style={{
          padding: "5px 25px 0",
          paddingLeft: bom.level === 1 ? 0 : "60px",
        }}
      >
        <TableContainer>
          <Table style={{ width: "100%" }} className={classes.noBorder}>
            <TableBody>
              <TableRow>
                <TableCell style={{ paddingRight: 0 }}>
                  <div style={{ width: "60px", float: "left" }}>
                    <Input
                      className={classes.quantityInput}
                      value={
                        bom.data.presetQuantity
                          ? bom.data.presetQuantity * bom.parentItem.quantity
                          : 1 * bom.parentItem.quantity
                      }
                      disabled={true}
                    />
                  </div>
                  <div
                    style={{
                      width: "calc(100% - 60px)",
                      float: "left",
                      lineHeight: "28px",
                    }}
                  >
                    {bom.data.name}
                  </div>
                </TableCell>
                {/* <TableCell>
						{bom.data.name}
					</TableCell> */}
                {/* <TableCell style={{ width: '10%', textAlign: 'right' }}>{bom.data.price}</TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {bom.data.bom &&
          bom.data.bom.length > 0 &&
          bom.data.bom
            .sort((a, b) =>
              a && b ? a.displaySequence - b.displaySequence : 0,
            )
            .map((child) => (
              <BomItem
                data={child}
                parentItem={bom.parentItem}
                level={bom.level + 1}
              />
            ))}
      </div>
    )
  );
};

export default withTranslation("translations")(InlineItem);
